module.exports = __webpack_public_path__ + "static/media/35-7.11d61ef1.mp3";